export const ACTIVITY_FIELD_KEY = Object.freeze({
  TITLE: "activitytitle",
  OWNER: "activityowner",
  DUE_DATE: "activityduedate",
  DUE_DATE_TZ: "activityduedatetz",
  DESCRIPTION: "activitydescription",
  SKILLSET: "chooseaskillset",
  ASSIGNMENT: "chooseanassignmentmethod",
});

export const ACTIVITY_FIELD_LABEL = Object.freeze({
  TITLE: "Activity Title",
  OWNER: "Activity Owner",
  DUE_DATE: "Activity Due Date",
  DESCRIPTION: "Activity Description",
  SKILLSET: "Choose a skillset",
  ASSIGNMENT: "Choose an assignment method",
});

export const OWNER_PLACEHOLDER = "Select Activity Owner";